import {AUTH_KEYS} from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
    path: '/change-password',
    component: Layout,
    name: 'Change password',
    meta: {title: 'change_password', auth: AUTH_KEYS.CHANGE_PASSWORD},
    children: [
        {
            path: '',
            name: 'Change password',
            component: () => import('@/views/ChangePassword/Index.vue'),
            meta: {
                title: 'Change password',
                isHide: true
            }
        }
    ]
};
